<template>
  <div class="cart-details">
    <template v-if="getItems.length > 0">
      <div
        v-for="product in getItems"
        :key="product._id"
        class="cart-line"
      >
        <div class="cart-qty-badge" aria-hidden="true">{{ product.cant }}</div>

        <div class="cart-line-main">
          <div class="cart-line-name">{{ product.nombre }}</div>
          <div v-if="product.discoint !== product.precio" class="cart-line-price">
            <span>${{ linePrice(product.discoint, product.cant) }}</span>
            <del class="cart-line-old">${{ linePrice(product.precio, product.cant) }}</del>
          </div>
          <div v-else class="cart-line-price">
            ${{ linePrice(product.precio, product.cant) }}
          </div>
        </div>

        <div
          v-if="!readonly && $route.name !== 'Checkout'"
          class="cart-stepper"
        >
          <button
            type="button"
            class="cart-stepper-btn"
            :aria-label="product.cant <= 1 ? 'Quitar del carrito' : 'Reducir cantidad'"
            @click.stop="changeQty(product, -1)"
          >
            <v-icon small>{{ product.cant <= 1 || !allowsQtyEdit(product) ? 'mdi-delete-outline' : 'mdi-minus' }}</v-icon>
          </button>
          <span class="cart-stepper-value">{{ product.cant }}</span>
          <button
            type="button"
            class="cart-stepper-btn"
            aria-label="Aumentar cantidad"
            :disabled="!allowsQtyEdit(product)"
            @click.stop="changeQty(product, 1)"
          >
            <v-icon small>mdi-plus</v-icon>
          </button>
        </div>
      </div>
    </template>
    <div v-else class="cart-empty">
      Tu carrito está vacío. Elegí productos de la carta para armar tu pedido.
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'CartDetails',
  props: {
    readonly: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters('Carrito', ['getItems', 'getTotalItems'])
  },
  methods: {
    ...mapActions('Carrito', ['removeItem', 'adjustLineQuantity']),
    linePrice (unit, cant) {
      const n = (Number(unit) || 0) * (Number(cant) || 1)
      return n.toLocaleString('es-AR')
    },
    changeQty (product, delta) {
      if (delta < 0 && (product.cant <= 1 || !this.allowsQtyEdit(product))) {
        this.removeItem(product)
        return
      }
      if (!this.allowsQtyEdit(product) && delta > 0) return
      this.adjustLineQuantity({ _id: product._id, delta })
    },
    allowsQtyEdit (product) {
      return product && !product.esCombinado
    }
  }
}
</script>

<style scoped>
.cart-details {
  text-align: left;
}
.cart-line {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 14px 0;
  border-bottom: 1px solid #efefef;
}
.cart-line:last-child {
  border-bottom: none;
}
.cart-qty-badge {
  flex: 0 0 28px;
  width: 28px;
  height: 28px;
  border-radius: 8px;
  background: var(--v-primary-base, #7800C6);
  color: #fff;
  font-size: 0.85rem;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-top: 2px;
}
.cart-line-main {
  flex: 1;
  min-width: 0;
}
.cart-line-name {
  font-size: 0.98rem;
  font-weight: 600;
  line-height: 1.3;
  color: rgba(0, 0, 0, 0.87);
}
.cart-line-price {
  margin-top: 4px;
  font-size: 0.9rem;
  color: rgba(0, 0, 0, 0.55);
  display: flex;
  align-items: center;
  gap: 8px;
}
.cart-line-old {
  opacity: 0.55;
}
.cart-stepper {
  display: inline-flex;
  align-items: center;
  border: 1px solid #e0e0e0;
  border-radius: 10px;
  overflow: hidden;
  background: #fff;
  flex-shrink: 0;
}
.cart-stepper-btn {
  width: 34px;
  height: 34px;
  border: none;
  background: transparent;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: rgba(0, 0, 0, 0.7);
}
.cart-stepper-btn:disabled {
  opacity: 0.35;
  cursor: not-allowed;
}
.cart-stepper-value {
  min-width: 1.5rem;
  text-align: center;
  font-weight: 600;
  font-size: 0.9rem;
}
.cart-empty {
  padding: 16px 4px;
  color: rgba(0, 0, 0, 0.6);
  font-size: 0.95rem;
  line-height: 1.4;
}
</style>
